import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from '../../../styles/Accordion.module.scss';
import { handleImpressionsTrack, sendOtp } from '../../../api';
import { useAuth } from '../../../contexts/auth';
import { handleResendTimer } from '../../../reducersAndActions/actions/authAction';
import { clickTracker } from '../../../lib/common';

export default function Reasons({
  data,
  setData,
  setCurrentComponent,
  currentComponent,
  status,
  setReasonCancel,
  projectId,
  faqObj,
}) {
  const reasons = [
    'Business close down',
    'Personal/ Financial issue',
    'No benefit',
    'Leads issue',
    'False committment',
  ];
  const [_reason, _setReason] = useState('');
  const [authState, authDispatch] = useAuth();

  const handleProceedClick = async () => {
    await clickTracker(`FAQ_${status.toLowerCase()}_proceed`, `ecs_FAQ_${status.toLowerCase()}`);
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `cta_proceed`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `issue_ecs`;
      const llTrdInside = `faq_${faqObj?.faqKey}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
    }
    setData({ ...data, reasons: _reason });
    if (status.toLowerCase() === 'reactivate') {
      if (projectId === 'csportal') {
        const res = await sendOtp();
        handleResendTimer(authDispatch, {
          ...authState,
          resendOtp: true,
        });
        if (res) setCurrentComponent(currentComponent + 1);
      }
    } else {
      setCurrentComponent(currentComponent + 1);
    }
  };
  return (
    <div>
      <>
        <div className="font12 fw700 color111 mt-2">Please select a reason for stopping your ECS</div>

        <ul className={`${styles.Accordion__Items} mt-15`}>
          {reasons.map((item, idx) => {
            return (
              <li className={`${styles.Accordion__Item}`}>
                <label htmlFor={`ecs_reasons_checkbox_${idx}`} className={` ${styles.Accordion__Checkbox__Lable}`}>
                  <input
                    id={`ecs_reasons_checkbox_${idx}`}
                    className={`${styles.Accordion__Checkbox__Input} `}
                    type="radio"
                    name="sidcity_radio"
                    onChange={async () => {
                      _setReason(item);
                      await clickTracker(`FAQ_stop_${item}`, 'ecs_FAQ_stop');
                    }}
                  />
                  <span className={`${styles.Accordion__Checkbox__Icon} csicon `} />
                  <span className={` ${styles.Accordion__Checkbox__Text} font14 fw400 color111`}>{item} </span>
                </label>
              </li>
            );
          })}
        </ul>

        <div className={`${styles.Accordion__Contant__Btnbox}`}>
          <button
            type="button"
            className={`${styles.Accordion__Contant__Button} blue_whitefill_animate font14 fw600 color007 mt-20`}
            style={{
              border: '1px solid #0076D7',
              backgroundColor: '#E5F1FB',
            }}
            onClick={async () => {
              setCurrentComponent(currentComponent - 1);
              await clickTracker(`FAQ_${status.toLowerCase()}_cancel`, `ecs_FAQ_${status.toLowerCase()}`);
              setReasonCancel(true);
              if (projectId === 'csportal') {
                const liVal = 'click';
                const liTrd = `cta_cancel`;
                const faqTypeVal = '';
                const othersData = [];
                const llTrd = `issue_ecs`;
                const llTrdInside = `faq_${faqObj?.faqKey}`;
                await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
              }
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            className={`${styles.Accordion__Contant__Button} bluefill_animate font14 fw600 colorFFF mt-20`}
            style={{
              backgroundColor: `${_reason ? '#0076d7' : 'transparent'}`,
              border: `1px solid ${!_reason ? '#E0E0E0' : '#0076d7'}`,
              transitionProperty: 'background-color, background-image, border-color, box-shadow',
              transition: 'all 0.8s',
              color: `${_reason ? '#fff' : 'rgb(197, 167, 167)'}`,
            }}
            disabled={!_reason}
            onClick={() => handleProceedClick()}
          >
            Proceed
          </button>
        </div>
      </>
    </div>
  );
}

Reasons.propTypes = {
  data: PropTypes.object,
  setData: PropTypes.func,
  setCurrentComponent: PropTypes.func,
  currentComponent: PropTypes.number,
  status: PropTypes.string,
  setReasonCancel: PropTypes.func,
  projectId: PropTypes.string,
  faqObj: PropTypes.object,
};
